// extracted by mini-css-extract-plugin
export var contact = "Footer-module--contact--c666e";
export var copyright = "Footer-module--copyright--ec0ab";
export var footer = "Footer-module--footer--8740e";
export var icon = "Footer-module--icon--b3988";
export var index = "Footer-module--index--fd493";
export var layout = "Footer-module--layout--18584";
export var links = "Footer-module--links--e001e";
export var list = "Footer-module--list--92939";
export var logo = "Footer-module--logo--30f43";
export var navigation = "Footer-module--navigation--1c0dd";
export var platform = "Footer-module--platform--ce6a6";
export var social = "Footer-module--social--156ba";
export var socket = "Footer-module--socket--6fe26";
export var socketList = "Footer-module--socket-list--bef44";
export var socketNavigation = "Footer-module--socket-navigation--cdf67";